// Copyright (c) 2017 Deere & Company

import SpaDetailsContainer from '../../tcsm/spa-details/state-connector';

export default {
    component: SpaDetailsContainer,
    name: 'SPECIAL_ALLOWANCE_CLAIM',
    path: 'spa/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/spa.js